var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pu_foot"},[_c('div',{staticClass:"pu_row"},[_c('div',{staticClass:"pu_contents"},[_c('div',{staticClass:"pu_copyright"},[_vm._v(" © Copyright "),_c('a',{attrs:{"href":"http://hyper-nomad.com"}},[_vm._v("HyperNomad")]),_vm._v(". All Rights Reserved ")])])])])
}]

export { render, staticRenderFns }